<div class="retry-container">
  <button
    mat-raised-button
    color="accent"
    [disabled]="disabled"
    (click)="onRetry()"
    class="retry-button"
  >
    <mat-icon>refresh</mat-icon>
    <span>Try again</span>
  </button>
</div>
